import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { LegalEntityDetails } from '@app/models/project.models';
import type {
  DecisionBadgeGroup,
  DecisionBadgeItem,
} from '@app/models/status.model';
import { DecisionBadgeListComponent } from '@app/ui-components/decision-badge-list/decision-badge-list.component';
import { TranslateModule } from '@ngx-translate/core';

type InvestorCriterionId = 'minCapital' | 'minRevenue' | 'minBalance';
type StatementId = 'confirmAccuracy';
type InvestorGroup = DecisionBadgeGroup<'investorRating', InvestorCriterionId>;
type StatementGroup = DecisionBadgeGroup<'statement', StatementId>;

@Component({
  selector: 'app-qualification-tab',
  standalone: true,
  imports: [CommonModule, TranslateModule, DecisionBadgeListComponent],
  templateUrl: './qualification-tab.component.html',
  styleUrl: './qualification-tab.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class QualificationTabComponent {
  @Input() entity: LegalEntityDetails | null = null;

  get isProfessionalClient(): boolean {
    return this.entity?.professionalCertificate === true;
  }

  get isQualificationNotFilled(): boolean {
    return this.entity?.stepInvestorQualification !== true;
  }

  get badgeGroups(): ReadonlyArray<InvestorGroup | StatementGroup> {
    const entity = this.entity;

    const investorRating: InvestorGroup = {
      groupId: 'investorRating',
      title: 'general.investmentQualification',
      completedAt: entity?.investorQualificationLastDate ?? null,
      items: [
        {
          id: 'minCapital',
          labelKey: 'admin.legalEntities.qualification.criteria.minCapital',
          value: entity?.question1_60kor100kYearlyPortfolio ?? null,
        },
        {
          id: 'minRevenue',
          labelKey: 'admin.legalEntities.qualification.criteria.minRevenue',
          value:
            entity?.question2_YearinLeadLeadRoleWhere2mNetIncomeOrProf ?? null,
        },
        {
          id: 'minBalance',
          labelKey: 'admin.legalEntities.qualification.criteria.minBalance',
          value:
            entity?.question3_HasSignificantMarketActivityFor4QuarterTenTransaction ??
            null,
        },
      ] as ReadonlyArray<DecisionBadgeItem<InvestorCriterionId>>,
    };

    const statement: StatementGroup = {
      groupId: 'statement',
      title: 'general.statement',
      items: [
        {
          id: 'confirmAccuracy',
          labelKey:
            'admin.legalEntities.qualification.statement.confirmAccuracy',
          value: entity?.stepInvestorQualification ?? null,
        },
      ] as ReadonlyArray<DecisionBadgeItem<StatementId>>,
    };

    return [investorRating, statement];
  }
}
